// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// FeathersJS Client
import io from 'socket.io-client'
import feathers from '@feathersjs/feathers'
import socketio from '@feathersjs/socketio-client'
import auth from '@feathersjs/authentication-client'
import vueFeathers from 'vue-feathers'

// Vuelidate for form validations
import Vuelidate from 'vuelidate'

// Vue Material
import VueMaterial from 'vue-material'

// Localstorage
import VueLocalStorage from 'vue-localstorage'

// Vue Toasted
import Toasted from 'vue-toasted'

// moment JS
import moment from 'moment'

// Vue moment
import VueMomentJS from 'vue-momentjs'
// Vue Countdown
import VueCountdown from '@chenfengyuan/vue-countdown'

// Vue material usage
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(VueMaterial)

// Feathers JS usage
let url = 'milesguide.herokuapp.com'
// let url = 'localhost:3030'
const application = feathers()
let socket = io('https://' + url, {transports: ['websocket'], secure: true}) // IP and port of the server
// let socket = io('http://' + url) // IP and port of the server
application
  .configure(socketio(socket))
  .configure(auth({
    header: 'Authorization',
    cookie: 'feathers-jwt',
    storageKey: 'milesJWT',
    jwtStrategy: 'jwt',
    path: '/authentication',
    entity: 'user',
    service: 'users',
    jwt: {
      algorithm: 'HS256', // the algorithm to use
      expiresIn: '365d' // the access token expiry
    },
    timeout: 10000,
    storage: window.localStorage // Passing a WebStorage-compatible object to enable automatic storage on the client.
  }))
application.service('users')
application.service('usertypes')
application.service('bookings')
application.service('bookingassignments')
application.service('fleet')
application.service('fleetassignment')
application.service('fleetpictures')
application.service('departments')
Vue.use(vueFeathers, application)

// Vuelidate Usage
Vue.use(Vuelidate)

// Localstorage Usage
Vue.use(VueLocalStorage)

// Toasted
Vue.use(Toasted)

// Vue moment
Vue.use(VueMomentJS, moment)
// Countdown
Vue.component(VueCountdown.name, VueCountdown)

// All Filters

Vue.filter('timeAgo', function (value) {
  if (value) {
    return moment(value).fromNow()
  }
})

Vue.filter('dateToReadable', function (value) {
  if (value) {
    let readDate = moment(value).format('LLLL')
    return readDate
  }
})

Vue.filter('timeToReadable', function (value) {
  if (value) {
    let readDate = moment(value).format('LLLL')
    return readDate
  }
})

// All Filters
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js